import { effect, signalObject } from "omi";

type Container = "main" | "panel";

const layoutContainerRefs = signalObject<Record<Container, HTMLElement | null>>({
  main: null,
  panel: null,
});

export function useLayoutContainer() {
  const register = (ref: HTMLElement, name: Container) => {
    if (layoutContainerRefs[name].value == null) {
      layoutContainerRefs[name].value = ref;
    }
  };

  const onRegister = ({ func, name = "main" }: { func: (ref: HTMLElement) => void; name?: Container }) => {
    effect(() => {
      if (layoutContainerRefs[name].value) {
        func(layoutContainerRefs[name].value!);
      }
    });
  };

  const unregister = (name: Container = "main") => {
    if (layoutContainerRefs[name].value != null) {
      layoutContainerRefs[name].value = null;
    }
  };

  const getRef = (name: Container = "main") => {
    return layoutContainerRefs[name].value;
  };

  return { refs: layoutContainerRefs, onRegister, unregister, register, getRef };
}
